export default function testimonialsRotator() {
  const roots = Array.from(document.querySelectorAll('[data-testimonials-rotator]'));
  if (!roots.length) return;

  for (const root of roots) {
    const items = Array.from(root.querySelectorAll('.testimonials--item'));
    if (items.length <= 1) continue;

    const interval = Number.parseInt(root.getAttribute('data-interval') || '8000', 10);
    const ms = Number.isNaN(interval) ? 8000 : interval;

    let idx = items.findIndex((el) => el.classList.contains('is-active'));
    if (idx < 0) idx = 0;

    const activate = (nextIdx) => {
      items[idx].classList.remove('is-active');
      idx = nextIdx;
      items[idx].classList.add('is-active');
    };

    let timer = window.setInterval(() => {
      activate((idx + 1) % items.length);
    }, ms);

    // Pause on hover/focus for usability
    root.addEventListener('mouseenter', () => {
      window.clearInterval(timer);
    });
    root.addEventListener('mouseleave', () => {
      timer = window.setInterval(() => {
        activate((idx + 1) % items.length);
      }, ms);
    });
  }
}
